import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ServiceWhiteIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "34",
        height: "43",
        viewBox: "0 0 34 43",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.87457 7.92214C1.36116 9.40212 -0.352011 13.1052 1.2399 16.886C3.2982 21.7737 12.3553 24.5489 12.7813 24.6111C13.1637 24.6702 13.6114 24.4494 13.6114 24.0266C13.6114 23.6037 12.7813 20.0916 12.7813 19.8428C12.7813 19.5941 12.9212 19.3702 13.1606 19.2707C13.4 19.1712 23.9029 14.7189 27.3852 13.2544C30.8675 11.79 32.5185 7.84752 31.0199 4.29059C29.5212 0.733654 25.557 -0.817841 22.056 0.655922C18.5551 2.12969 8.38797 6.44526 4.87457 7.92214Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M29.2067 34.655C32.7201 33.1751 34.4333 29.472 32.8414 25.6912C30.7831 20.8035 21.726 18.0463 21.3 17.9841C20.9176 17.925 20.4698 18.1458 20.4698 18.5686C20.4698 18.9915 21.3 22.4856 21.3 22.7343C21.3 22.9831 21.1601 23.2069 20.9207 23.3064C20.6813 23.4059 10.1784 27.8583 6.69604 29.3227C3.21373 30.7872 1.56274 34.7297 3.06138 38.2866C4.56002 41.8466 8.52425 43.395 12.0252 41.9212C15.5293 40.4475 25.6933 36.1319 29.2067 34.655Z",
                fill: "url(#paint0_linear_5448_47)"
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("linearGradient", {
                    id: "paint0_linear_5448_47",
                    x1: "23.645",
                    y1: "43.9893",
                    x2: "22.9349",
                    y2: "18.719",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "white"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.47",
                            stopColor: "white",
                            stopOpacity: "0.85"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "1",
                            stopColor: "white",
                            stopOpacity: "0.4"
                        })
                    ]
                })
            })
        ]
    });
